<template>
  <div class="sn-f-s-c sn-breadcrumb" v-if="breadcrumb.length > 0">
    <div class="current">当前位置：</div>
    <el-breadcrumb :separator="separator">
      <el-breadcrumb-item :key="i" v-for="(item, i) in breadcrumb"
      :to="!$sn.validate.empty(item.router) ? item.router : null" :replace="item.replace">{{ item.title }}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'sn-breadcrumb',
  props: {
    // 分隔符
    separator: {
      type: String,
      default: '>'
    },
    /*
    面包屑信息
    title[string]：展示名称
    replace[boolean]：是否使用 replace 进行跳转
    router[object]：仿照 router 进行传值
    */
    breadcrumb: {
      type: Array,
      default: () => []
    }
  }
};
</script>
<style lang="scss">
.sn-breadcrumb {
  @include fs(14);

  flex-shrink: 0;
  padding: 40px 20px 0;
}
</style>
